import React from "react";
import { FormControlLabel } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import { makeStyles } from "@material-ui/core/styles";
import { notBlank } from "../../../util/ext";

const useStyles = makeStyles(theme => ({
  italic: {
    fontStyle: "italic",
  },
}));

const AllowDownloadCheckbox = props => {
  const { onChange, value, licenseTypeError = null } = props;
  const classes = useStyles();

  return (
    <FormControlLabel
      style={{ marginLeft: 0 }}
      control={
        <Checkbox
          color="primary"
          checked={value}
          onChange={onChange}
          name="content-allowDownload"
          inputProps={{ "aria-label": "Select" }}
        />
      }
      label={
        <div style={{ marginTop: notBlank(licenseTypeError) ? 20 : 0 }}>
          <div>Allow this content to download</div>
          <div className={classes.italic}>
            (Open license types ALWAYS allow download)
          </div>
        </div>
      }
    />
  );
};

export default AllowDownloadCheckbox;
